import { Component } from "react"
import versionData from "../version.json"

const START_YEAR = 2024;

export default class Footer extends Component {
    render() {
        const currentYear = new Date().getFullYear();
        const yearRange = currentYear > START_YEAR ? `${START_YEAR}-${currentYear}` : `${START_YEAR}`;

        return (
            <div>
                <footer className="main-footer">
                    <strong>v{versionData.version}</strong>
                    {' · '}
                    <strong>&copy; {yearRange} <a href="https://www.webnou.ro">WebNou.ro</a></strong>
                    {' · '}<a href="https://www.webnou.ro/produse/mobile/app-webnou-ro/politica-de-confidentialitate.html" target="_blank" rel="noopener noreferrer">GDPR</a>
                </footer>
            </div>
        )
    }
}
